import { ContactEntity } from './contact-entity';
import { EntityBase } from './entity-base';

/**
 * Represents a customer entity with contact and business information.
 * @extends EntityBase
 * @class CustomerEntity
 */
export class CustomerEntity extends EntityBase {
  /**
   * The physical address of the customer.
   * @type {string}
   * @default ""
   * @example "123 Main St, City, State 12345"
   */
  public address: string = "";

  /**
   * The customer's website URL.
   * @type {string}
   * @default ""
   * @example "https://www.customer.com"
   */
  public website: string = "";

  /**
   * The GST (Goods and Services Tax) number of the customer.
   * @type {string}
   * @default ""
   * @example "12ABCDE1234F5Z5"
   */
  public gstNumber: string = "";

  /**
   * The primary contact person for this customer.
   * @type {ContactEntity}
   * @default new ContactEntity()
   */
  public contactPerson: ContactEntity = new ContactEntity();
}
